import { createContext } from "react";
import { WorkspaceList } from "src/context/api/workspaces";
import { UseFormReturn } from "react-hook-form";
import { WorkspaceFormData } from "./types";

export default createContext<{
    workspace?: WorkspaceList;
    countries: { name: string, code: string }[];
    isFetchingCountries: boolean;
    error: any;
    formMethods: UseFormReturn<WorkspaceFormData>;
    validation: boolean;
    ready: boolean;
    onInvalid: () => void;
    onValid: () => void;
    setError: (error: any) => void;
    setReady: (ready: boolean) => void;
}>({
    workspace: {} as WorkspaceList,
    countries: [],
    isFetchingCountries: false,
    error: null,
    formMethods: {} as UseFormReturn<WorkspaceFormData>,
    validation: false,
    ready: false,
    onInvalid: () => { },
    onValid: () => { },
    setError: () => { },
    setReady: () => { },
})